exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.head-title-2 {\n  padding: 7px 16px;\n  background-color: #f8f8f9;\n}\n", "", {"version":3,"sources":["E:/eview/efview/src/components/form/formdetailtwo.vue"],"names":[],"mappings":";AACA;EACE,kBAAkB;EAClB,0BAA0B;CAC3B","file":"formdetailtwo.vue","sourcesContent":["\n.head-title-2 {\n  padding: 7px 16px;\n  background-color: #f8f8f9;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"scoped":false,"sourceMap":false}!./node_modules/less-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/form/formdetailtwo.vue
// module id = 964
// module chunks = 0